import { axios } from '@/plugins/axios-pol'

const BASE = '/personal/api/EstadoFuerza'

export default class NovedadApiRepository {
  async getAll() {
    const { data } = await axios.get(`${BASE}/novedades`)
    return JSON.parse(data.data)
  }

  async getByPersonal(cuip) {
    const { data } = await axios.get(`${BASE}/personal/${cuip}/novedad`)
    return JSON.parse(data.data)
  }

  async create(idPersonal, novedad) {
    const { data } = await axios.post(`${BASE}/personal/${idPersonal}/novedad`, novedad)
    return data.data
  }

  async update(idPersonal, idNovedad, novedad) {
    const { data } = await axios.put(`${BASE}/personal/${idPersonal}/novedad/${idNovedad}`, novedad)
    return data.data
  }

}
